import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, BoxProps } from 'components/ui';
import { getDesignToken } from 'styles/constants';

export const ItemRow = ({ isLastItem, style, ...props }: BoxProps & { isLastItem: boolean }) =>
  React.createElement(Box, {
    ...props,
    style: [styles.itemRow, isLastItem && styles.lastItemRow, style],
  });

export const AddExtrasDebugMenuContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.debugContainer, style] });

const styles = StyleSheet.create({
  itemRow: {
    borderBottomColor: getDesignToken('border-color-options'),
    borderBottomWidth: 1,
  },
  lastItemRow: {
    borderBottomWidth: 0,
  },
  debugContainer: {
    backgroundColor: getDesignToken('icon-button-primary'),
  },
});
